import SurveysCreate from './SurveysCreate'
export {SurveysCreate}
export default SurveysCreate
